
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-leave",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.658 4.511s-1.701-.765-1.701 1.021 1.685 2.985 1.707 2.981a10.854 10.854 0 014.942 9.107c0 5.909-4.723 10.717-10.606 10.864-5.882-.147-10.605-4.955-10.605-10.864 0-3.813 1.967-7.167 4.942-9.107.021.004 1.707-1.195 1.707-2.981s-1.701-1.021-1.701-1.021C5.349 6.769 1.874 11.789 1.874 17.62c0 7.852 6.299 14.233 14.127 14.38 7.827-.148 14.127-6.529 14.127-14.38 0-5.832-3.474-10.851-8.468-13.109z"}}),_c('path',{attrs:{"d":"M16.099 0c-1.583 0-2.077 1.158-2.077 1.61v14.167c0 .452.494 1.61 2.077 1.61s1.88-1.158 1.88-1.61V1.61c0-.452-.297-1.61-1.88-1.61z"}})])
          )
        }
      }
    